module.exports = __webpack_public_path__ + "assets/img/children.0f315e74.svg";